<app-card>
  <app-card-header
    title="Trainingstiere - Top 3"
    [subTitle]="headerSubtitle"
    [iconPath]="'assets/icons/medal.svg'"
    [showLoadingSpinner]="fetchRequest === RequestStateEnum.PENDING"
  />

  <div class="flex flex-col items-start gap-1 justify-center">
    @for (index of [0, 1, 2]; track index) {
      <div
        class="bg-light-grey px-5 py-3 rounded-r-lg min-w-32 transition-all duration-400"
        [ngClass]="{ 'opacity-60': getCheckIns(index) === 0 }"
        [ngStyle]="{ width: podium().length > 0 ? getWidth(podium()[index]) : '0px' }"
      >
        <div class="flex flex-col font-md leading-4 gap-1">
          <span class="text-dark-grey font-medium">{{ getCheckIns(index) }} Check-Ins</span>

          @if (getNumberOfPeople(index) > 1 || getNumberOfPeople(index) === 0) {
            <span class="text-mid-grey">{{ getNumberOfPeople(index) }} Personen</span>
          } @else {
            <span class="text-mid-grey">{{ getNumberOfPeople(index) }} Person</span>
          }
        </div>
      </div>
    }
    <p class="text-center align-middle w-full font-medium text-dark-grey mt-4">
      @switch (userCheckInCount) {
        @case (0) {
          Diesen Monat hast du noch keinen Check-In.
        }
        @case (1) {
          Du hast diesen Monat bereits
          <strong class="text-blue underline underline-offset-2">einen Check-In!</strong>
        }
        @default {
          Du hast diesen Monat bereits
          <strong class="text-blue underline underline-offset-2"
            >{{ userCheckInCount }} Check-Ins!</strong
          >
        }
      }
    </p>
  </div>
</app-card>
